import { useCallback, useMemo, useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import {
  isWeatherForecastSubscribed,
  markWeatherForecastSubscribed,
} from '../../lib/weatherSubscriptionStorage';

/** Local subscription memory for the current map point (per signed-in or entered email). */
export function useWeatherSubscription(lat: number, lng: number) {
  const userEmail = useAuthStore((s) => s.user?.email ?? '');
  const [subscribedEmail, setSubscribedEmail] = useState<string | null>(null);

  const activeEmail = subscribedEmail ?? userEmail;

  const isSubscribed = useMemo(
    () => isWeatherForecastSubscribed(activeEmail, lat, lng),
    [activeEmail, lat, lng],
  );

  const markSubscribed = useCallback(
    (email: string) => {
      const trimmed = email.trim();
      if (!trimmed) return;
      markWeatherForecastSubscribed(trimmed, lat, lng);
      setSubscribedEmail(trimmed.toLowerCase());
    },
    [lat, lng],
  );

  return { isSubscribed, markSubscribed };
}
